import util from '../../common/util';
import { emitTrack, regType } from './register-track';
import advRegister from './advertising-register/register.js';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
export default {
    props: {
        name: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'register'
        },
        optionsFn: {
            type: Function,
            default() {
                return () => ({});
            }
        }
    },
    // i18next: {
    //     translationResourcesLoaded() {
    //         this.options = this.optionsFn(this.currentLanguage);
    //     }
    // },
    data: function() {
        let options = this.optionsFn(this.currentLanguage);
        return {
            options,
            isShow: false,
            showType: this.type || 'register',
            popMaskClass: options.popMaskClass || '',
            popCustomClass: options.popCustomClass || '',
            allowCloseForced: false,
            allowCloseForcedVal: false,
            showAdvRegister: false,
            hasLender: false
        };
    },
    computed: {
        ...mapState(usePageStore, ['page', 'currentLanguage']),
        isMobileSize() {
            return this.platform.isMobile
        },
        allowClose() {
            let allowClose = true;
            if (this.allowCloseForced) {
                allowClose = this.allowCloseForcedVal;
            } else {
                if (this.showType === 'register') {
                    if (this.options.allowRegistClose !== undefined) {
                        allowClose = this.options.allowRegistClose;
                    } else if (this.options.allowClose !== undefined) {
                        allowClose = this.options.allowClose;
                    }
                } else {
                    if (this.options.allowLoginClose !== undefined) {
                        allowClose = this.options.allowLoginClose;
                    } else if (this.options.allowClose !== undefined) {
                        allowClose = this.options.allowClose;
                    }
                }
            }
            if (this.showAdvRegister) {
                allowClose = false;
            }
            return allowClose;
        },
        popAnimation() {
            if (this.options.popAnimation === undefined) {
                return 'fadeIn';
            } else {
                return this.options.popAnimation;
            }
        },
        fbLeadClass({ page }) {
            if (this.showType === 'register') {
                return page.FBAppId && util.getCookie('_ads_source') === '15'
                    ? 'come-fb-lead-from'
                    : '';
            } else {
                return '';
            }
        },
        closeIcon() {
            return this.options.closeIcon || 'icon-close';
        }
    },
    methods: {
        changeType(type) {
            if (type == 'register' && advRegister.isShow(this.page)) {
                this.showAdvRegister = true;
            } else {
                this.showAdvRegister = false;
            }
            this.showType = type;
        },
        changeAllowClose(value) {
            this.allowCloseForced = true;
            this.allowCloseForcedVal = value;
        },
        onClose() {
            if (this.showType === 'register') {
                emitTrack(regType.close);
            }
            this.options && this.options.onClose && this.options.onClose();
        }
    },
    provide() {
        return {
            hasLender: () => this.hasLender
        };
    },
    created() {
        if (this.page.ownerId && !this.platform.isBot) {
            this.axiosIns(
                `/api-site/lender/getActiveLendersByAgentId?agentId=${this.page.ownerId}`
            ).then(res => {
                this.hasLender = !!res?.data?.data?.length;
            });
        }
    },
    beforeMount() {
        this.onLngNsLoaded().then(() => {
            this.options = this.optionsFn(this.currentLanguage);
        })
    }
};
